import React, { useContext } from 'react';
import facebookImg from '../../assets/images/facebook-3.png';
import linkedinImg from '../../assets/images/linkedin-2.png';
import twitterImg from '../../assets/images/twitter-2.png';
import { AccountContext } from '../../context';
import Footer from '../Footer';

const Social: React.FC = () => {
  const {
    userData,
    setUserData,
    userMetaData,
    onUserMetaDataChange,
    METADATANAMES,
    handleSubmit,
    isSubmitting
  } = useContext(AccountContext);

  const handleInputChange = (e) => {
    const otherSocialLinks =
      userMetaData?.social_links?.filter(
        (el) => el?.platform !== e?.target?.name
      ) || [];
    const actualSocialLink = {
      platform: e?.target?.name,
      social_link: e?.target?.value,
    };
    onUserMetaDataChange({
      ...userMetaData,
      social_links: [...otherSocialLinks, actualSocialLink],
    });
  };

  const getSocialUrl = (platform) => {
    return (
      userMetaData?.social_links?.find((el) => el?.platform === platform)
        ?.social_link || ''
    );
  };

  return (
    <div data-name="social" className="manage-account-form-block w-form">
      <form
        onSubmit={handleSubmit}
        id="email-form-2"
        name="email-form-2"
        data-name="Email Form 2"
        method="get"
        className="manage-account-form"
        data-wf-page-id="65aec9c9e13ed74d8bfffe77"
        data-wf-element-id="7fd38463-19ec-a6db-9949-03f3af5f543c"
      >
        <div className="w-layout-hflex-account-ui tabs-content">
          <div className="w-layout-vflex-account-ui account-input-block social-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                Facebook
              </label>
              <label
                htmlFor="name"
                className="form-input-label required hidden"
              >
                *
              </label>
            </div>
            <div className="w-layout-hflex-account-ui account-socials-input-group">
              <div className="w-layout-hflex-account-ui account-social-logo-block">
                <img
                  src={facebookImg}
                  loading="lazy"
                  alt=""
                  className="account-social-logo-icon"
                />
              </div>
              <input
                className="form-input social-form-input w-input"
                maxLength={256}
                name="facebook"
                value={getSocialUrl('facebook')}
                onChange={handleInputChange}
                data-name="Organisation Name 3"
                placeholder="Facebook Username"
                custom-value="Personal"
                type="text"
                id="organisation-name-3"
              />
            </div>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block social-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                LinkedIn
              </label>
              <label
                htmlFor="name"
                className="form-input-label required hidden"
              >
                *
              </label>
            </div>
            <div className="w-layout-hflex-account-ui account-socials-input-group">
              <div className="w-layout-hflex-account-ui account-social-logo-block">
                <img
                  src={linkedinImg}
                  loading="lazy"
                  alt=""
                  className="account-social-logo-icon smaller"
                />
              </div>
              <input
                className="form-input social-form-input w-input"
                maxLength={256}
                name="linkedin"
                value={getSocialUrl('linkedin')}
                onChange={handleInputChange}
                data-name="Organisation Name 3"
                placeholder="LinkedIn Username"
                custom-value="Personal"
                type="text"
                id="organisation-name-3"
              />
            </div>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block social-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                X
              </label>
              <label
                htmlFor="name"
                className="form-input-label required hidden"
              >
                *
              </label>
            </div>
            <div className="w-layout-hflex-account-ui account-socials-input-group">
              <div className="w-layout-hflex-account-ui account-social-logo-block">
                <img
                  src={twitterImg}
                  loading="lazy"
                  alt=""
                  className="account-social-logo-icon smaller"
                />
              </div>
              <input
                className="form-input social-form-input w-input"
                maxLength={256}
                name="twitter"
                value={getSocialUrl('twitter')}
                onChange={handleInputChange}
                data-name="Organisation Name 3"
                placeholder="Twitter Username"
                custom-value="Personal"
                type="text"
                id="organisation-name-3"
              />
            </div>
          </div>
          {/*<div className="w-layout-vflex-account-ui account-input-block social-input-block">
                        <div className="w-layout-hflex-account-ui label-block"><label htmlFor="name"
                                                                           className="form-input-label">Instagram</label><label
                            htmlFor="name" className="form-input-label required hidden">*</label>
                        </div>
                        <div className="w-layout-hflex-account-ui account-socials-input-group">
                            <div className="w-layout-hflex-account-ui account-social-logo-block"><img
                                src={instagramImg} loading="lazy" alt=""
                                className="account-social-logo-icon"/></div>
                            <input className="form-input social-form-input w-input" maxLength="256"

                                   value={getSocialUrl("instagram")} onChange={()=>{}} data-name="Organisation Name 3"
                                   placeholder="https://instagram.com/ibl" custom-value="Personal"
                                   type="text" id="organisation-name-3"/>
                        </div>
                    </div>
                    <div className="w-layout-vflex-account-ui account-input-block social-input-block">
                        <div className="w-layout-hflex-account-ui label-block"><label htmlFor="name"
                                                                           className="form-input-label">Pinterest</label><label
                            htmlFor="name" className="form-input-label required hidden">*</label>
                        </div>
                        <div className="w-layout-hflex-account-ui account-socials-input-group">
                            <div className="w-layout-hflex-account-ui account-social-logo-block"><img
                                src={pinterestImg} loading="lazy" alt=""
                                className="account-social-logo-icon"/></div>
                            <input className="form-input social-form-input w-input" maxLength="256"

                                   value={getSocialUrl("pinterest")} onChange={()=>{}} data-name="Organisation Name 3"
                                   placeholder="https://pinterest.com/ibl" custom-value="Personal"
                                   type="text" id="organisation-name-3"/>
                        </div>
                    </div>*/}
        </div>
        <Footer isSubmitting={isSubmitting} handleSubmit={handleSubmit} />
      </form>
      <div className="w-form-done">
        <div>Thank you! Your submission has been received!</div>
      </div>
      <div className="w-form-fail">
        <div>Oops! Something went wrong while submitting the form.</div>
      </div>
    </div>
  );
};

export default Social;
